import PropTypes from 'prop-types';

const triStateBooleanShape = PropTypes.oneOf(['yes', 'no', '']);

export default triStateBooleanShape;
